var __TEMP__ = require('./_baseProperty.js');var baseProperty = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_basePropertyDeep.js');var basePropertyDeep = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_isKey.js');var isKey = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_toKey.js');var toKey = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = property;
